import { Directive, ElementRef, HostListener } from '@angular/core';
import { Overlay, OverlayConfig, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { TimepickerComponent } from './timepicker.component';


@Directive({
  selector: 'input[type="time"]'
})
export class TimepickerDirective {
  private el
  constructor(
    el: ElementRef,
    private _overlay: Overlay
    ) {
    el.nativeElement.type='text'
    el.nativeElement.classList.add('pickup-time-input')
    this.el = el
  }

  @HostListener('focus') onFocus() {
    this.showPickup();
    this.el.nativeElement.blur()
  }
  
  private highlight(color: string) {
    this.el.nativeElement.style.backgroundColor = color;
  }

  private showPickup(){
    const rect = this.el.nativeElement.getBoundingClientRect();
    const scrollStrategy = this._overlay.scrollStrategies.block();
    let overlayRef:any = this._overlay.create({
      positionStrategy: this._overlay.position()
          .global()
          .left((rect.left - 12) + 'px')
          .top((rect.top + 34)+'px'),
      hasBackdrop: true,
      scrollStrategy,
      backdropClass:['cdk-overlay-dark-backdrop','pickup-time-backdrop']
    })
    let ref = overlayRef.attach(new ComponentPortal(TimepickerComponent))
    overlayRef.backdropClick().subscribe(() => {
      overlayRef.dispose();
    });
    ref.instance.close.subscribe(() => overlayRef.detach());
    ref.instance.el = this.el
  }
}
